import MyAiAssistantAPI from 'dashboard/api/my_ai/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'MyAiAssistant',
  API: MyAiAssistantAPI,
});
